import { render, staticRenderFns } from "./checkbox-side.vue?vue&type=template&id=10bd4b3a&scoped=true"
import script from "./checkbox-side.vue?vue&type=script&lang=js"
export * from "./checkbox-side.vue?vue&type=script&lang=js"
import style0 from "./checkbox-side.vue?vue&type=style&index=0&id=10bd4b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd4b3a",
  null
  
)

export default component.exports